type Content<T> = T[] | Record<string, T>;
type Func<T> = (item: T, key: string) => boolean;
type Process<T> = { extracted: T[], rest: [ string, T ][] };

const processing = <TChild>(content: Content<TChild>, extract: Func<TChild>) =>
  Object.entries(content).reduce((acc, cur) => {
    const match = extract(cur[1], cur[0]);
    match && acc.extracted.push(cur[1]);
    !match && acc.rest.push(cur);
    return acc;
  }, { extracted: [], rest: [] } as Process<TChild>);

export const extract = <TChild, TContent extends Content<TChild> = TChild[]>(content: Content<TChild>, extract: Func<TChild>):
  { extracted: TChild[], rest: TContent }  => {
  const { extracted, rest } = processing(content, extract);
  return {
    extracted,
    rest: (Array.isArray(content) ? rest.map(([_, item]) => item) : Object.fromEntries(rest)) as TContent
  };
}

export const extractOne = <TChild, TContent extends Content<TChild> = TChild[]>(content: TContent, extract: Func<TChild>):
  { extracted?: TChild, rest: TContent }  => {
  const { extracted, rest } = processing(content, extract);
  return {
    extracted: extracted[0] || undefined,
    rest: (Array.isArray(content) ? rest.map(([_, item]) => item) : Object.fromEntries(rest)) as TContent
  };
}
